import * as React from 'react';
import Stack from '@mui/material/Stack';
import { Gauge } from '@mui/x-charts/Gauge';

export default function GaugeValueRangeNoSnap() {
  return (
    <Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 1, md: 3 }} >
      <Gauge width={250} height={250} value={75} centertext="75%" />
      <div 
          style={{
            position: 'absolute',
            fontFamily:"SF Pro Display",
            fontSize: '16px',
            fontWeight: 'normal',
            color: '#3E4143',
            margin:"0",
            paddingTop:"30px",
          }}
        >Completed</div>
    </Stack>
  );
}
